import { useState, FormEvent } from "react";
import { useAuth } from "../providers/authProvider";

export const LoginScreen = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(undefined);
    const result = await login({ username, password });
    setLoading(false);
    if (!result.success) setError(result.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-950 dark:text-neutral-100">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 p-6">
        <h1 className="text-2xl font-semibold">log-pile</h1>
        <p className="text-sm text-neutral-500">
          Log in with your doridium account. <span className="font-medium">Admin accounts only</span> — log-pile holds other people's error data, so a regular doridium login will be turned away after signing in.
        </p>
        <input className="w-full border rounded px-3 py-2 dark:bg-neutral-900 dark:border-neutral-700" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" />
        <input className="w-full border rounded px-3 py-2 dark:bg-neutral-900 dark:border-neutral-700" placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button className="w-full bg-neutral-900 text-white rounded px-3 py-2 disabled:opacity-50 dark:bg-neutral-100 dark:text-neutral-900" disabled={loading}>
          {loading ? "Logging in…" : "Log in"}
        </button>
      </form>
    </div>
  );
};
